<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="14.745" height="10" viewBox="0 0 14.745 10">
		<g id="b" transform="translate(8.463 1.714)">
			<g id="c">
				<g id="Group_29576" data-name="Group 29576">
					<path
						id="d"
						d="M8.633,1.493a1.014,1.014,0,0,1,0-.179A.9.9,0,0,0,7.666.49H5.75V7.059H7.325"
						transform="translate(-2.873 -0.485)"
						fill="none"
						stroke="#5a677d"
						stroke-linecap="round"
						stroke-miterlimit="10"
						stroke-width="0.962"
					/>
					<path
						id="e"
						d="M1.783,7.054H3.358V.481H1.447a.9.9,0,0,0-.966.824,1.014,1.014,0,0,1,0,.179"
						transform="translate(-0.481 -0.481)"
						fill="none"
						stroke="#5a677d"
						stroke-linecap="round"
						stroke-miterlimit="10"
						stroke-width="0.962"
					/>
				</g>
			</g>
		</g>
		<g id="Group_24110" data-name="Group 24110" transform="translate(0.5 0.5)">
			<path
				id="Path_20182"
				data-name="Path 20182"
				d="M670.561,378.913h2a1.5,1.5,0,0,1,1.5,1.5v6a1.5,1.5,0,0,1-1.5,1.5h-2a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5Z"
				transform="translate(-669.061 -378.913)"
				fill="none"
				stroke="#5a677d"
				stroke-width="1"
			/>
			<g id="Group_23895" data-name="Group 23895" transform="translate(0 3.001)">
				<line id="Line_627" data-name="Line 627" x2="5" fill="none" stroke="#5a677d" stroke-width="1" />
				<line id="Line_628" data-name="Line 628" x2="5" transform="translate(0 3)" fill="none" stroke="#5a677d" stroke-width="1" />
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TableTextIndicatorSVG',
};
</script>

<style scoped lang="scss"></style>
